import { useNavigate } from "react-router-dom";
import { ArrowLeft, CaretRight, Info, EnvelopeSimple, ShieldCheck, FileText } from "@phosphor-icons/react";
import { track } from "@/lib/track";

const mono = { fontFamily: "IBM Plex Mono, monospace" };

const ROWS = [
  { to: "/about", label: "About North of Six", icon: Info },
  { to: "/contact", label: "Contact us", icon: EnvelopeSimple },
  { to: "/privacy", label: "Privacy Policy", icon: ShieldCheck },
  { to: "/terms", label: "Terms & Conditions", icon: FileText },
];

/**
 * Settings screen, reached from Profile. For now it's the in-app home for the
 * About / Contact / legal pages; those pages themselves are public routes.
 */
const Settings = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAF9F5]">
      <header className="border-b border-[#E4E1D9] px-6 md:px-12 py-4 flex items-center gap-4">
        <button
          onClick={() => navigate("/profile")}
          className="flex items-center gap-2 text-[#6B6A68] hover:text-[#1A1A1A] transition-colors text-xs uppercase tracking-[0.2em]"
          style={mono}
          data-testid="settings-back"
        >
          <ArrowLeft size={16} /> Back
        </button>
        <h1
          className="text-2xl md:text-3xl tracking-tighter ml-2"
          style={{ fontFamily: "Cormorant Garamond, serif" }}
        >
          Settings
        </h1>
      </header>

      <main className="max-w-md mx-auto px-6 py-10 md:py-14">
        <p className="text-xs uppercase tracking-[0.2em] mb-3 text-[#6B6A68]" style={mono}>
          About & legal
        </p>
        <div className="bg-white border border-[#E4E1D9] rounded-md divide-y divide-[#E4E1D9]">
          {ROWS.map(({ to, label, icon: Icon }) => (
            <button
              key={to}
              type="button"
              onClick={() => {
                track("nav_click", { nav_item: to.slice(1), destination: to, source: "settings" });
                navigate(to);
              }}
              className="w-full flex items-center gap-3 px-4 py-4 hover:bg-[#FAF9F5] transition-colors"
              data-testid={`settings-link-${to.slice(1)}`}
            >
              <Icon size={20} className="shrink-0 text-[#2D302A]" />
              <span className="flex-1 text-left text-sm text-[#2D302A]">{label}</span>
              <CaretRight size={16} className="shrink-0 text-[#9A9A98]" />
            </button>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Settings;
